import { render, staticRenderFns } from "./importAssignment.vue?vue&type=template&id=6f7dd046"
import script from "./importAssignment.vue?vue&type=script&lang=js"
export * from "./importAssignment.vue?vue&type=script&lang=js"
import style0 from "./importAssignment.vue?vue&type=style&index=0&id=6f7dd046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports